import Style from "@assets/css/workshope.module.css";
import { handleClassNames } from "lib/cssHelpers";
import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  fetchRecommendedByBrandWorkshop,
  fetchRecommendedOBAssuredWorkshop,
  fetchRecommendedWorkshop,
  getWorkshopsProductCategory,
} from "../../redux/actions/apiActions";
import { toast } from "react-hot-toast";
import {
  setCarPopup,
  setLoader,
  toggleChooseCar,
} from "../../redux/actions/globalAction";
import { FaCar } from "react-icons/fa";
import { gtmWorkshopCollection } from "../../lib/google-tag-manager";
import { useRouter } from "next/router";

const WorkshopCard = ({
  apiData,
  cart,
  fetchRecommendedByBrandWorkshop,
  fetchRecommendedOBAssuredWorkshop,
  fetchRecommendedWorkshop,
  profile,
  globalData,
  setCarPopup,
  setLoader,
  toggleChooseCar,
  getWorkshopsProductCategory,
}) => {
  const [tab, setTab] = useState("nearest");
  const [dataRecommended, setDataRecommended] = useState(null);
  const [dataOBAssured, setDataOBAssured] = useState(null);
  const [dataByBrand, setDataByBrand] = useState(null);
  const [show, setShow] = useState(false);
  const carNameParam = "car";
  const router = useRouter();

  const handleClasses = (classValue) => {
    return handleClassNames(classValue, Style);
  };

  useEffect(() => {
    // Test Area profile.location to globalData.locationData
    if (globalData.locationData.lat != 0) {
      fetchRecommendedWorkshop(
        globalData.locationData.lat,
        globalData.locationData.lng,
        100
      );
    }
  }, [globalData.locationData]);

  useEffect(() => {
    if (globalData.locationData?.lat != 0 && globalData.carData?.brandId) {
      fetchRecommendedByBrandWorkshop(
        globalData.locationData?.lat,
        globalData.locationData?.lng,
        globalData.carData?.brandId
      );
    }
  }, [globalData.locationData, globalData.carData]);

  useEffect(() => {
    if (apiData.recommendedWorkshops?.length > 10) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [apiData.recommendedWorkshops]);

  useEffect(() => {
    setDataRecommended(apiData.recommendedWorkshops);
    setDataOBAssured(apiData.recommendedOBAssuredWorkshops);
    setDataByBrand(apiData.recommendedByBrandWorkshops);
  }, [
    apiData.recommendedWorkshops,
    apiData.recommendedOBAssuredWorkshops,
    apiData.recommendedByBrandWorkshops,
  ]);

  const handleExperts = () => {
    setShow(true);
    if (globalData.carData?.brandId) {
      setTab("byBrand");
      if (globalData.locationData.lat != 0) {
        profile.selectedCar?.brandId &&
          fetchRecommendedByBrandWorkshop(
            globalData.locationData.lat,
            globalData.locationData.lng,
            profile.selectedCar?.brandId
          );
      }
    } else {
      toast("Select Car to View Experts!", {
        icon: <FaCar />,
        style: {
          color: "#F58B1F",
          fontWeight: "bold",
        },
      });
      setCarPopup("brand");
      toggleChooseCar(true);
    }
  };

  const handleOffers = () => {
    setShow(true);
    setTab("obAssured");
    if (globalData.locationData.lat != 0) {
      fetchRecommendedOBAssuredWorkshop(
        globalData.locationData.lat,
        globalData.locationData.lng
      );
    }
  };
  const calculateGoogleRating = (rate) => {
    return rate * 20;
  };

  const handleFilter = (filter) => {
    setShow(true);
    setTab(filter);
  };

  const handleWorkshop = (e) => {
    setLoader(true);
    sessionStorage.setItem("isWorkshopCollection", true);
    localStorage.setItem("selected-service-title", e.Name);
    getWorkshopsProductCategory(e?.Id, globalData.carData?.modelId);
    gtmWorkshopCollection(e.Name);
    router.push(
      `/services/${
        globalData.locationData?.data?.EmirateAreaSlug || "dubai"
      }/oil-change/${carNameParam}/${e.Slug}`
    );
  };

  return (
    <section className={handleClasses("wshop-card-section")}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="ws-cl-hd">
              <div className="text-center title-anim">
                <div className="header-all">Workshop Collections</div>
              </div>
              <p className="text-center subHead-all ">
                We have curated a list of our partners servicing all your needs
              </p>
              <div className={handleClasses("filter-ws")}>
                <strong>Filter by : </strong>
                <ul className="cs-nav nav" id="myTab" role="tablist">
                  <li
                    onClick={() => handleFilter("nearest")}
                    className={handleClasses("nav-item")}
                  >
                    <a
                      className={
                        tab == "nearest" ? handleClasses("active") : ""
                      }
                      id="home-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      Nearest
                    </a>
                  </li>
                  <li
                    onClick={() => handleOffers()}
                    className={handleClasses("nav-item")}
                  >
                    <a
                      className={
                        tab == "obAssured" ? handleClasses("active") : ""
                      }
                      id="profile-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      Offers
                    </a>
                  </li>
                  <li
                    onClick={() => handleExperts()}
                    className={handleClasses("nav-item")}
                  >
                    <a
                      className={
                        tab == "byBrand" ? handleClasses("active") : ""
                      }
                      id="contact-tab"
                      data-toggle="tab"
                      role="tab"
                      aria-controls="contact"
                      aria-selected="false"
                    >
                      {globalData.carData?.brand} Experts
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="tab-content" id="myTabContent">
              {tab == "nearest" ? (
                <div
                  className={handleClasses("tab-pane fade")}
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="row">
                    {dataRecommended ? (
                      show ? (
                        dataRecommended?.slice(0, 9).map((item) => {
                          return (
                            <div
                              className="col-md-4"
                              onClick={() => handleWorkshop(item)}
                            >
                              <div className={handleClasses("card-cs")}>
                                <div className={handleClasses("car-img")}>
                                  <div className={handleClasses("nr-loca")}>
                                    <img
                                      src="assets/images/map-OB.png"
                                      alt="ob-location"
                                    />
                                    <span>
                                      {parseFloat(item.Distance).toFixed(0)} KM
                                    </span>
                                  </div>
                                  <img
                                    className={handleClasses("img-fluid")}
                                    src={item.CoverImageUrl}
                                    alt="logo"
                                  />
                                </div>
                                <div className={handleClasses("card-body-cs")}>
                                  <h5
                                    className={handleClasses(
                                      "card-title-cs ellipsis"
                                    )}
                                  >
                                    {item.Name}
                                  </h5>
                                  <h6
                                    className={handleClasses(
                                      "card-subtitle ellipsis"
                                    )}
                                  >
                                    {item.AreaName}
                                  </h6>
                                </div>
                                <div className={handleClasses("card-ft")}>
                                  <div className={handleClasses("nr-lc-txt")}>
                                    <span className={handleClasses("ellipsis")}>
                                      Nearest Landmark
                                    </span>
                                    <strong
                                      className={handleClasses(
                                        item.NearestLandmark
                                          ? "ellipsis"
                                          : "ellipsis no-nearby"
                                      )}
                                    >
                                      {" "}
                                      {item.NearestLandmark ||
                                        "No nearby landmarks."}
                                    </strong>
                                  </div>
                                  <div className={handleClasses("nr-wp-str")}>
                                    <div
                                      className={handleClasses("star-rating")}
                                    >
                                      <div
                                        className={handleClasses("back-stars")}
                                      >
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>

                                        <div
                                          className={handleClasses(
                                            "front-stars"
                                          )}
                                          style={{
                                            width: calculateGoogleRating(
                                              item.GoogleRating
                                            ),
                                          }}
                                        >
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        dataRecommended?.map((item) => {
                          return (
                            <div
                              className="col-md-4"
                              onClick={() => handleWorkshop(item)}
                            >
                              <div className={handleClasses("card-cs")}>
                                <div className={handleClasses("car-img")}>
                                  <div className={handleClasses("nr-loca")}>
                                    <img
                                      src="assets/header/map-OB.png"
                                      alt="ob-location"
                                    />
                                    <span>
                                      {parseFloat(item.Distance).toFixed(0)} KM
                                    </span>
                                  </div>
                                  <img
                                    className={handleClasses("img-fluid")}
                                    src={item.CoverImageUrl}
                                    alt="logo"
                                  />
                                </div>
                                <div className={handleClasses("card-body-cs")}>
                                  <h5
                                    className={handleClasses(
                                      "card-title-cs ellipsis"
                                    )}
                                  >
                                    {item.Name}
                                  </h5>
                                  <h6
                                    className={handleClasses(
                                      "card-subtitle ellipsis"
                                    )}
                                  >
                                    {item.AreaName}
                                  </h6>
                                </div>
                                <div className={handleClasses("card-ft")}>
                                  <div className={handleClasses("nr-lc-txt")}>
                                    <span className={handleClasses("ellipsis")}>
                                      Nearest Landmark
                                    </span>
                                    <strong
                                      className={handleClasses(
                                        item.NearestLandmark
                                          ? "ellipsis"
                                          : "ellipsis no-nearby"
                                      )}
                                    >
                                      {" "}
                                      {item.NearestLandmark ||
                                        "No nearby landmarks."}
                                    </strong>
                                  </div>
                                  <div className={handleClasses("nr-wp-str")}>
                                    <div
                                      className={handleClasses("star-rating")}
                                    >
                                      <div
                                        className={handleClasses("back-stars")}
                                      >
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>

                                        <div
                                          className={handleClasses(
                                            "front-stars"
                                          )}
                                          style={{
                                            width: calculateGoogleRating(
                                              item.GoogleRating
                                            ),
                                          }}
                                        >
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )
                    ) : dataRecommended?.length == 0 ? (
                      <div className="col-md-12 bg-grey-official p-5">
                        <div className="d-flex justify-content-center align-items-center">
                          <img
                            src="/assets/work-in-progress.webp"
                            height="250px"
                            alt="progress"
                          />
                          <div className="ml-md-5">
                            <h1>Stay Tuned!</h1>
                            <p className="text-dark">
                              We are working on to bring you a great experience.
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : null}

              {tab == "obAssured" ? (
                <div
                  className={handleClasses("tab-pane fade")}
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="row">
                    {dataOBAssured ? (
                      show ? (
                        dataOBAssured?.slice(0, 9).map((item) => {
                          return (
                            <div
                              className="col-md-4"
                              onClick={() => handleWorkshop(item)}
                            >
                              <div className={handleClasses("card-cs")}>
                                <div className={handleClasses("car-img")}>
                                  <div className={handleClasses("nr-loca")}>
                                    <img
                                      src="assets/header/map-OB.png"
                                      alt="ob-location"
                                    />
                                    <span>
                                      {parseFloat(item.Distance).toFixed(0)} KM
                                    </span>
                                  </div>
                                  <img
                                    className={handleClasses("img-fluid")}
                                    src={item.CoverImageUrl}
                                    alt="CoverImage"
                                  />
                                </div>
                                <div className={handleClasses("card-body-cs")}>
                                  <h5
                                    className={handleClasses(
                                      "card-title-cs ellipsis"
                                    )}
                                  >
                                    {item.Name}
                                  </h5>
                                  <h6
                                    className={handleClasses(
                                      "card-subtitle ellipsis"
                                    )}
                                  >
                                    {item.AreaName}
                                  </h6>
                                </div>
                                <div className={handleClasses("card-ft")}>
                                  <div className={handleClasses("nr-lc-txt")}>
                                    <span className={handleClasses("ellipsis")}>
                                      Nearest Landmark
                                    </span>
                                    <strong
                                      className={handleClasses(
                                        item.NearestLandmark
                                          ? "ellipsis"
                                          : "ellipsis no-nearby"
                                      )}
                                    >
                                      {" "}
                                      {item.NearestLandmark ||
                                        "No nearby landmarks."}
                                    </strong>
                                  </div>
                                  <div className={handleClasses("nr-wp-str")}>
                                    <div
                                      className={handleClasses("star-rating")}
                                    >
                                      <div
                                        className={handleClasses("back-stars")}
                                      >
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>

                                        <div
                                          className={handleClasses(
                                            "front-stars"
                                          )}
                                          style={{
                                            width: calculateGoogleRating(
                                              item.GoogleRating
                                            ),
                                          }}
                                        >
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        dataOBAssured?.map((item) => {
                          return (
                            <div
                              className="col-md-4"
                              onClick={() => handleWorkshop(item)}
                            >
                              <div className={handleClasses("card-cs")}>
                                <div className={handleClasses("car-img")}>
                                  <div className={handleClasses("nr-loca")}>
                                    <img
                                      src="assets/header/map-OB.png"
                                      alt="ob-location"
                                    />
                                    <span>
                                      {parseFloat(item.Distance).toFixed(0)} KM
                                    </span>
                                  </div>
                                  <img
                                    className={handleClasses("img-fluid")}
                                    src={item.CoverImageUrl}
                                    alt="CoverImage"
                                  />
                                </div>
                                <div className={handleClasses("card-body-cs")}>
                                  <h5
                                    className={handleClasses(
                                      "card-title-cs ellipsis"
                                    )}
                                  >
                                    {item.Name}
                                  </h5>
                                  <h6
                                    className={handleClasses(
                                      "card-subtitle ellipsis"
                                    )}
                                  >
                                    {item.AreaName}
                                  </h6>
                                </div>
                                <div className={handleClasses("card-ft")}>
                                  <div className={handleClasses("nr-lc-txt")}>
                                    <span className={handleClasses("ellipsis")}>
                                      Nearest Landmark
                                    </span>
                                    <strong
                                      className={handleClasses(
                                        item.NearestLandmark
                                          ? "ellipsis"
                                          : "ellipsis no-nearby"
                                      )}
                                    >
                                      {" "}
                                      {item.NearestLandmark ||
                                        "No nearby landmarks."}
                                    </strong>
                                  </div>
                                  <div className={handleClasses("nr-wp-str")}>
                                    <div
                                      className={handleClasses("star-rating")}
                                    >
                                      <div
                                        className={handleClasses("back-stars")}
                                      >
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>

                                        <div
                                          className={handleClasses(
                                            "front-stars"
                                          )}
                                          style={{
                                            width: calculateGoogleRating(
                                              item.GoogleRating
                                            ),
                                          }}
                                        >
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )
                    ) : dataOBAssured?.length == 0 ? (
                      <div className="col-md-12 bg-grey-official p-5">
                        <div className="d-flex justify-content-center align-items-center">
                          <img
                            src="/assets/work-in-progress.webp"
                            height="250px"
                            alt="progress"
                          />
                          <div className="ml-md-5">
                            <h1>Stay Tuned!</h1>
                            <p className="text-dark">
                              We are working on to bring you a great experience.
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : null}

              {tab == "byBrand" ? (
                <div
                  className={handleClasses("tab-pane fade")}
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="row">
                    {dataByBrand ? (
                      show ? (
                        dataByBrand?.slice(0, 9).map((item) => {
                          return (
                            <div
                              className="col-md-4"
                              onClick={() => handleWorkshop(item)}
                            >
                              <div className={handleClasses("card-cs")}>
                                <div className={handleClasses("car-img")}>
                                  <div className={handleClasses("nr-loca")}>
                                    <img
                                      src="assets/header/map-OB.png"
                                      alt="ob-location"
                                    />
                                    <span>
                                      {parseFloat(item.Distance).toFixed(0)} KM
                                    </span>
                                  </div>
                                  <img
                                    className={handleClasses("img-fluid")}
                                    src={item.CoverImageUrl}
                                    alt="CoverImage"
                                  />
                                </div>
                                <div className={handleClasses("card-body-cs")}>
                                  <h5
                                    className={handleClasses(
                                      "card-title-cs ellipsis"
                                    )}
                                  >
                                    {item.Name}
                                  </h5>
                                  <h6
                                    className={handleClasses(
                                      "card-subtitle ellipsis"
                                    )}
                                  >
                                    {item.AreaName}
                                  </h6>
                                </div>
                                <div className={handleClasses("card-ft")}>
                                  <div className={handleClasses("nr-lc-txt")}>
                                    <span className={handleClasses("ellipsis")}>
                                      Nearest Landmark
                                    </span>
                                    <strong
                                      className={handleClasses(
                                        !item.NearestLandmark
                                          ? "ellipsis"
                                          : "ellipsis no-nearby"
                                      )}
                                    >
                                      {" "}
                                      {item.NearestLandmark ||
                                        "No nearby landmarks."}
                                    </strong>
                                  </div>
                                  <div className={handleClasses("nr-wp-str")}>
                                    <div
                                      className={handleClasses("star-rating")}
                                    >
                                      <div
                                        className={handleClasses("back-stars")}
                                      >
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>

                                        <div
                                          className={handleClasses(
                                            "front-stars"
                                          )}
                                          style={{
                                            width: calculateGoogleRating(
                                              item.GoogleRating
                                            ),
                                          }}
                                        >
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        dataByBrand?.map((item) => {
                          return (
                            <div
                              className="col-md-4"
                              onClick={() => handleWorkshop(item)}
                            >
                              <div className={handleClasses("card-cs")}>
                                <div className={handleClasses("car-img")}>
                                  <div className={handleClasses("nr-loca")}>
                                    <img
                                      src="assets/header/map-OB.png"
                                      alt="ob-location"
                                    />
                                    <span>
                                      {parseFloat(item.Distance).toFixed(0)} KM
                                    </span>
                                  </div>
                                  <img
                                    className={handleClasses("img-fluid")}
                                    src={item.CoverImageUrl}
                                    alt="CoverImage"
                                  />
                                </div>
                                <div className={handleClasses("card-body-cs")}>
                                  <h5
                                    className={handleClasses(
                                      "card-title-cs ellipsis"
                                    )}
                                  >
                                    {item.Name}
                                  </h5>
                                  <h6
                                    className={handleClasses(
                                      "card-subtitle ellipsis"
                                    )}
                                  >
                                    {item.AreaName}
                                  </h6>
                                </div>
                                <div className={handleClasses("card-ft")}>
                                  <div className={handleClasses("nr-lc-txt")}>
                                    <span className={handleClasses("ellipsis")}>
                                      Nearest Landmark
                                    </span>
                                    <strong
                                      className={handleClasses(
                                        !item.NearestLandmark
                                          ? "ellipsis"
                                          : "ellipsis no-nearby"
                                      )}
                                    >
                                      {" "}
                                      {item.NearestLandmark ||
                                        "No nearby landmarks."}
                                    </strong>
                                  </div>
                                  <div className={handleClasses("nr-wp-str")}>
                                    <div
                                      className={handleClasses("star-rating")}
                                    >
                                      <div
                                        className={handleClasses("back-stars")}
                                      >
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>
                                        <i
                                          className="fa fa-star"
                                          aria-hidden="true"
                                        ></i>

                                        <div
                                          className={handleClasses(
                                            "front-stars"
                                          )}
                                          style={{
                                            width: calculateGoogleRating(
                                              item.GoogleRating
                                            ),
                                          }}
                                        >
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                          <i
                                            className="fa fa-star"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )
                    ) : dataByBrand?.length == 0 ? (
                      <div className="col-md-12 bg-grey-official p-5">
                        <div className="d-flex justify-content-center align-items-center">
                          <img
                            src="/assets/work-in-progress.webp"
                            height="250px"
                            alt="progress"
                          />
                          <div className="ml-md-5">
                            <h1>Stay Tuned!</h1>
                            <p className="text-dark">
                              We are working on to bring you a great experience.
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                        <div className="col-md-4">
                          <Skeleton style={{ width: "100%", height: 300 }} />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : null}

              {(dataRecommended?.length > 9 && tab == "nearest") ||
              (dataOBAssured?.length > 9 && tab == "obAssured") ||
              (dataByBrand?.length > 9 && tab == "byBrand") ? (
                <div
                  style={{ cursor: "pointer", margin: "20px auto" }}
                  onClick={() => setShow(!show)}
                  className="col-lg-2 col-m col-4 workshop-btn-sec"
                >
                  <div
                    className="workshop-view-btn"
                    style={{ textAlign: "center" }}
                  >
                    <strong>{show ? "View More" : "View Less"}</strong>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchRecommendedWorkshop: (lat, lang, size) => {
      dispatch(fetchRecommendedWorkshop(lat, lang, size));
    },
    fetchRecommendedOBAssuredWorkshop: (lat, lang) => {
      dispatch(fetchRecommendedOBAssuredWorkshop(lat, lang));
    },
    fetchRecommendedByBrandWorkshop: (lat, lang, carId) => {
      dispatch(fetchRecommendedByBrandWorkshop(lat, lang, carId));
    },
    setCarPopup: (flag) => {
      dispatch(setCarPopup(flag));
    },
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
    toggleChooseCar: (flag) => {
      dispatch(toggleChooseCar(flag));
    },
    getWorkshopsProductCategory: (id, mId) => {
      dispatch(getWorkshopsProductCategory(id, mId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkshopCard);
